import {createListenerMiddleware} from '@reduxjs/toolkit';
import type {TypedStartListening, TypedAddListener} from '@reduxjs/toolkit';
import type {RootState, AppDispatch} from '../index.ts';

export const listenerMiddleware = createListenerMiddleware();

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;
export type AppAddListener = TypedAddListener<RootState, AppDispatch>;

export const startAppListening =
  listenerMiddleware.startListening as AppStartListening;
